export default {
    _prefix: "qualityFormEditor.evaluationFocus",
    labels: {
        title: "Evaluation Focus",
        options: {
            FullInteraction: "Full Interaction",
            EvaluatedAgent: "Evaluated Agent",
        },
    },
};
